'use client';

import MetricLineChart from '../MetricLineChart';
import MetricBarChart from '../MetricBarChart';

// Sample data: Lead time percentiles over time
const percentileData = [
  { name: 'Sprint 1', P50: 18, P75: 32, P95: 48 },
  { name: 'Sprint 2', P50: 16, P75: 28, P95: 45 },
  { name: 'Sprint 3', P50: 14, P75: 25, P95: 40 },
  { name: 'Sprint 4', P50: 12, P75: 22, P95: 36 },
  { name: 'Sprint 5', P50: 10, P75: 18, P95: 32 },
  { name: 'Sprint 6', P50: 8, P75: 15, P95: 28 },
];

// Sample data: Time breakdown by stage
const stageData = [
  { name: 'Code Review', hours: 2.5, percentage: 40 },
  { name: 'CI/CD', hours: 0.5, percentage: 8 },
  { name: 'Testing', hours: 0.7, percentage: 11 },
  { name: 'Approval', hours: 1.2, percentage: 20 },
  { name: 'Deployment', hours: 0.5, percentage: 8 },
  { name: 'Verification', hours: 0.8, percentage: 13 },
];

export function LeadTimePercentilesChart() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📊 Lead Time Percentiles Over Time</h3>
      <MetricLineChart
        data={percentileData}
        lines={[
          { dataKey: 'P50', name: 'P50 (Median)', color: '#6FCF97' },
          { dataKey: 'P75', name: 'P75', color: '#4A90E2' },
          { dataKey: 'P95', name: 'P95', color: '#E89841' },
        ]}
        xAxisLabel="Sprint"
        yAxisLabel="Lead Time (hours)"
        targetLine={24}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing consistent improvement across all percentiles. The green dashed line represents
        the Elite threshold (&lt; 24 hours). P50 has improved from 18 to 8 hours.
      </p>
    </div>
  );
}

export function LeadTimeBottleneckChart() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🔍 Bottleneck Analysis</h3>
      <MetricBarChart
        data={stageData}
        bars={[
          { dataKey: 'hours', name: 'Time (hours)', color: '#E89841' },
        ]}
        xAxisLabel="Stage"
        yAxisLabel="Average Time (hours)"
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Code Review is the primary bottleneck at 2.5 hours (40% of total cycle time).
        Focus optimization efforts here for maximum impact.
      </p>
    </div>
  );
}
